import { useFetch } from 'lib/fetch';
import { redirect } from 'lib/location';
import { useCallback, useEffect, useState } from 'react';

export const useRegister = () => {
  const { fetch, result } = useFetch();
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [error, setError] = useState(null);

  const register = useCallback(() => {
    if (username && password) {
      fetch('POST', '/api/collection/user/register', { params: { username, password } });
    }
  }, [username, password]);

  useEffect(() => {
    if (result) {
      if (result?.error) {
        setError(result.error);
      } else {
        redirect('/login');
      }
    }
  }, [result]);

  return {
    register,
    username,
    setUsername,
    password,
    setPassword,
    error
  };
};
